module.exports = __webpack_public_path__ + "static/img/03.1ca6781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/05/03.jpg
// module id = ggMH
// module chunks = 1